import getContactForm from './getContactForm'
import deleteContactFormById from './deleteContactFormById'
import addContactForm from './addContactForm'
import setContactForm from './setContactForm'
import setContactFormSort from './setContactFormSort'
import importCsvContactFormOption from './importCsvContactFormOption'
import setContactFormButton from './setContactFormButton'
import setSelectContactFormButton from './setSelectContactFormButton'

export const getContactFormAPI = getContactForm
export const deleteContactFormByIdAPI = deleteContactFormById
export const addContactFormAPI = addContactForm
export const setContactFormAPI = setContactForm
export const setContactFormSortAPI = setContactFormSort
export const importCsvContactFormOptionAPI = importCsvContactFormOption
export const setContactFormButtonAPI = setContactFormButton
export const setSelectContactFormButtonAPI = setSelectContactFormButton



// WEBPACK FOOTER //
// ./src/store/modules/contact_forms/actions/index.js